// extracted by mini-css-extract-plugin
export default {"Steps21":"Steps21___B8r8U","ProgressBarBg":"ProgressBarBg___vzkJJ","ProgressBar":"ProgressBar___Bz0dI","ProgressCircle":"ProgressCircle___kArIJ","red":"red___l8FnZ"};